/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import UserMessages from 'app/modules/UserMessageModule.js';
import ConnectSocialDialog from '@/shadcn/components/AddSocialModal/ConnectSocialDialog.tsx';
import { SOCIAL_CREATE, SOCIAL_UPDATE } from 'app/redux/constants.js';

class BlueskyCreds extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            serviceId: this.props.app.config.constants.POST_SVC_BLUESKY,
            provider: 'bsky.social',
            handle: '',
            password: '',
            providerError: '',
            handleError: '',
            passwordError: '',
            apiError: '',
            isWorking: false
        };

        this.connectBluesky = this.connectBluesky.bind(this);
        this.closeAction = this.closeAction.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onSocialWritten = this.onSocialWritten.bind(this);

        /*
         * Connecting posts a create and reconnecting posts an update, and this
         * form handles the answer the same way either time. Held rather than
         * rebuilt: unregistering matches the object that registered.
         */
        this.writeCallbacks = [
            {action: SOCIAL_CREATE, func: this.onSocialWritten},
            {action: SOCIAL_UPDATE, func: this.onSocialWritten}
        ];

    }

    componentDidMount() {
        if (this.props.handle !== undefined && this.state.handle === '') {
            this.setState({
                handle: this.props.handle
            });
        }

        /*
         * Guarded the way SocialModal guards its own registration. This screen is
         * one of that modal's tabs, so it inherits whatever prop chain the host
         * had, and a guard on the parent alone leaves the subtree it mounts
         * unprotected.
         */
        if (typeof this.props.registerCallback === 'function') {
            this.writeCallbacks.map((callback) => { this.props.registerCallback(callback); });
        }

    }

    componentWillUnmount() {
        if (typeof this.props.unregisterCallback === 'function') {
            this.writeCallbacks.map((callback) => { this.props.unregisterCallback(callback); });
        }
    }

    /*
     * The credentials came back. Everything here is about the errors, since
     * Bluesky's are the kind the form has to print next to a field rather than
     * raise as a modal — a bad app password is a typo, not an account problem.
     */
    onSocialWritten() {
        let errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

        const clearSocialErrors = () => {
            this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
        };

        if (errors.length) {
            if (this.props.isDuplicateSocial()) {
    			let duplicateSocial = {};
                for (let i = 0; i < this.props.app.errors.api.length; ++i) {
                    if (this.props.app.errors.api[i].type === 'SOCIAL_CREATE' || this.props.app.errors.api[i].type === 'SOCIAL_UPDATE') {
                        duplicateSocial = this.props.app.errors.api[i].post;
                        duplicateSocial.force = true;
                    }
                }

    			this.props.showDuplicateSocialModal(duplicateSocial, {
    				confirm: clearSocialErrors,
    				cancel: clearSocialErrors
    			});

    		} else if (this.props.isOverTheLimit()) {
    			if (this.props.appName === "dlvr") {
    				this.props.showUpgradeModal(() => {
    					this.props.closeAllModals();
    				}, null, errors, 'social_error');
    			} else {
    				this.props.showClientSocialModal({
    					confirm: clearSocialErrors
    				});
    			}

    		} else if ((this.props.isBlacklisted() || this.props.isMovementRestricted()) && !this.state.modalUp) {
                if (this.props.isBlacklisted()) {
    			    this.props.showBlacklistModal({
    				    confirm: clearSocialErrors,
                    });
                } else {
                    this.props.showMovementRestrictedModal({
                        confirm: clearSocialErrors,
                    });
                }

    		} else {

                let action = (this.props.context === 'reconnect') ? 'reconnect' : 'connect',
                    showPermsError = false;

                for (let i = 0; i < errors.length; ++i) {
                    if (errors[i].errors.creds !== undefined) {
                        this.setState({
                            apiError: `We couldn't ${action} Bluesky. Check your handle and password.`
                        });
                    }
                    if (errors[i].errors.perms !== undefined && errors[i].errors.perms.code !== undefined && errors[i].errors.perms.code === 2023) {
                        showPermsError = true;
                    }
                    if (errors[i].errors.validation !== undefined) {
                        let keys = Object.keys(errors[i].errors.validation),
                            otherErrors = [];

                        for (let j = 0; j < keys.length; ++j) {
                            if (_.isString(errors[i].errors.validation[keys[j]])) {
                                otherErrors.push(errors[i].errors.validation[keys[j]]);
                            }
                        }

                        this.setState({
                            apiError: otherErrors.join("\n")
                        });

                    }
                }

                if (showPermsError) {
                    this.props.showUpgradeModal(() => {
                        clearSocialErrors();
                        this.props.closeAllModals();
                    }, null, errors, 'bluesky');
                }

                this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

    		}

        } else {
            this.props.closeAllModals();
            if (this.props.context === 'reconnect') {
                this.props.addMessage(UserMessages.generateMessage(UserMessages.social.reauthorized, 'SOCIAL_UPDATE'));
            }
            if (this.props.successCallback !== undefined && typeof this.props.successCallback === "function") {
                this.props.successCallback();
            }
        }

        this.setState({
            isWorking: false
        });

    }

    connectBluesky() {
        let apiError = '',
            providerError = '',
            handleError = '',
            passwordError = '',
            constants = this.props.app.config.constants,
            isWorking = this.state.isWorking;

        if (isWorking) {
            return;
        }

        if (this.state.provider.trim() === '') {
            providerError = "A Bluesky provider is required";
        }

        if (this.state.handle.trim() === '') {
            handleError = "Your Bluesky handle is required";
        }

        if (this.state.password.trim() === '') {
            passwordError = "App Password is required";
        }

        if (this.state.password.match(/[\w]{4}-[\w]{4}-[\w]{4}-[\w]{4}/ig) === null) {
            passwordError = "The App Password should have the form 'XXXX-XXXX-XXXX-XXXX'.";
        }

        if (!providerError && !handleError && !passwordError) {
            if (this.props.context !== undefined && this.props.context === "reconnect") {
                this.props.updateSocial({
                    id: this.props.paId,
                    creds: {
                        provider: this.state.provider.trim(),
                        handle: this.state.handle.trim(),
                        password: this.state.password.trim()
                    },
                    activeFlag: 1,
                    action: 'UPDATE'
                });
                isWorking = true;
            } else {
                let data = {
                    psID: constants.POST_SVC_BLUESKY,
                    creds: {
                        provider: this.state.provider.trim(),
                        handle: this.state.handle.trim(),
                        password: this.state.password.trim()
                    },
                    action: 'CREATE'
                };

                if (this.props.routeId !== undefined && this.props.routeId) {
                    data.rID = parseInt(this.props.routeId);
                }

                if (this.props.setNewSocial !== undefined && _.isFunction(this.props.setNewSocial)) {
                    this.props.setNewSocial(data);
                }

                this.props.createSocial(data);
                isWorking = true;
            }

        }

        this.setState({
            apiError,
            providerError,
            handleError,
            passwordError,
            isWorking
        });

    }

    onFieldChange(id, value) {
        let next = {};

        next[id] = String(value);
        // Each message names what was wrong with the previous value, so it stops
        // describing this one as soon as a key is pressed. The api error goes
        // with them: it was the verdict on the credentials being replaced.
        next[`${id}Error`] = '';
        next.apiError = '';

        this.setState(next);

    }

    /*
     * Back goes to this network's account list where there is one behind us, and
     * to the network picker otherwise — the two path checks are the surfaces with
     * no picker to return to.
     */
    closeAction() {
        let constants = this.props.app.config.constants;

        if (this.props.context === 'onboarding' || this.props.context === 'reconnect') {
            this.props.closeAllModals();
        }

        if (!this.props.router.location.pathname.match("/config/social") &&
            !this.props.router.location.pathname.match("/content/post") &&
            _.findWhere(this.props.socials.counts, {type: constants.POST_SVC_BLUESKY}) !== undefined) {
            this.props.switchView("chooseAcct", constants.POST_SVC_BLUESKY);
        } else {
            this.props.switchView("chooseType");
        }

    }

    /*
     * The three controls the frame draws. Service is fixed and shown disabled:
     * every account we support is on bsky.social, and the field exists so the
     * form says which service the handle belongs to.
     */
    fields() {
        return [
            {
                id: 'provider',
                label: 'Service',
                value: this.state.provider,
                disabled: true,
                error: this.state.providerError || undefined
            },
            {
                id: 'handle',
                label: 'Bluesky Handle',
                placeholder: '@username.bsky.social',
                value: this.state.handle,
                error: this.state.handleError || undefined,
                hint: [
                    "Log into Bluesky and go to Settings. Your handle is shown under \"Signed in as.\"",
                    'Format: yourhandle.bsky.social'
                ]
            },
            {
                id: 'password',
                label: 'Bluesky App Password',
                kind: 'password',
                placeholder: 'App password',
                value: this.state.password,
                error: this.state.passwordError || undefined,
                hint: [
                    'In Bluesky, go to Settings \u2192 App Passwords \u2192 Add App Password.',
                    'Copy the generated password and paste it here.'
                ],
                help: "You'll need to generate a unique password for dlvr.it. ",
                helpLink: {
                    label: 'Generate in Bluesky',
                    href: 'https://bsky.app/settings/app-passwords'
                }
            }
        ];
    }

    render() {
        let reconnecting = (this.props.context === 'reconnect');

        return (
            <ConnectSocialDialog
                screen="credentials"
                network="bluesky"
                title={(reconnecting) ? 'Reconnect Bluesky' : 'Connect Bluesky'}
                fields={this.fields()}
                error={this.state.apiError || undefined}
                primaryLabel={(reconnecting) ? 'Reconnect' : 'Connect'}
                loading={this.state.isWorking}
                backLabel="Back"
                onFieldChange={this.onFieldChange}
                onPrimary={this.connectBluesky}
                onBack={this.closeAction}
                onClose={this.props.closeAllModals} />
        );
    }
};

BlueskyCreds.displayName = "BlueskyCreds";

export default BlueskyCreds;
